<template>
  <form
    class="space-y-6"
    novalidate
    @submit="onNativeFormSubmit"
  >
    <FormInputText
      name="email"
      type="email"
      autocomplete="email"
      label="Email Address"
    />

    <div class="flex justify-end">
      <FormSubmitButton :is-submitting="isSubmitting">
        Email access link
      </FormSubmitButton>
    </div>
  </form>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import z from "zod"
import { emailAddressSchema } from "@/validation/sharedStringFieldSchemas"

const formSchema = z.object({
  email: emailAddressSchema("Email is required"),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: {
    email: "",
  },
})

const onNativeFormSubmit = handleSubmit(async (values) => {
  try {
    await requestMagicLinkMerchantGroupAdmin(values)
    toast.success(
      "If an active account was found, a link to log in to your account has been emailed to the given email address.",
      5000
    )
  } catch (error) {
    toast.error("Failed to request login link")
    logError(error)
  }
})
</script>
